<style scoped lang="scss" type="text/scss">
    .team-manager-container {
        display: flex;
        align-items: flex-start;

        .left-panel {
            width: 18rem;
            margin-right: 1rem;
        }

        .right-panel {
            flex: 1;
        }
    }
</style>

<template>
    <div class="team-manager-container">
        <school-basic-info class="left-panel"></school-basic-info>
        <card class="right-panel global-relative">
            <loading-placeholder :loading="requesting"></loading-placeholder>
            <el-table :data="subTeams" stripe border size="small" style="width: 100%">
                <el-table-column type="index" label="序号" align="center" width="80"></el-table-column>
                <el-table-column prop="name" label="队伍名称" align="center" min-width="150"></el-table-column>
                <el-table-column prop="manager_name" label="管理者" align="center" min-width="80">
                    <template slot-scope="scope">
                        <status-tag v-if="null === scope.row.manager_name" negative-text="未指定"
                                    :success="null !== scope.row.manager_name"></status-tag>
                        <span v-else>{{ scope.row.manager_name }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="150">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" plain @click="assign(scope.row)"
                                   v-text="scope.row.manager === null ? '指定管理者' : '更换管理者'"
                        >
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </card>
        <popup :visible.sync="popupVisible" :id="teamId" @need-reload="afterUpdate"></popup>
    </div>
</template>

<script>
    import SchoolBasicInfo from '../sub-components/school-basic-info';
    import Card from '../../../../../components/card';
    import StatusTag from '../../../../../components/status-tag/index';
    import {handleTeams} from '../../../../../utils/data-handler';
    import Popup from './popup';

    export default {
        name: '',
        components: {
            SchoolBasicInfo,
            Card,
            StatusTag,
            Popup
        },
        data () {
            return {
                subTeams: [],
                requesting: false,
                popupVisible: false,
                teamId: null
            };
        },
        computed: {
            currentManagedSchoolId () {
                return this.$store.state.school.currentManagedSchoolId;
            }
        },
        watch: {
            currentManagedSchoolId: {
                immediate: true,
                handler (id) {
                    if (id === null || id === undefined) return;
                    this.loadSubTeams();
                }
            }
        },
        methods: {
            afterUpdate () {
                this.loadSubTeams();
                this.$store.dispatch('team/loadManagedTeams').then();
            },
            loadSubTeams () {
                this.$normalRequest('school/loadSubTeams', {
                    id: this.currentManagedSchoolId
                }, false, false, this, 'requesting').then(data => {
                    this.subTeams = handleTeams(data);
                });
            },
            assign (team) {
                this.teamId = team.id;
                this.popupVisible = true;
            }
        }
    };
</script>
